/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faFilter} from '@fortawesome/pro-duotone-svg-icons';

const FilterToolIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faFilter} {...props} />
);

export default FilterToolIcon;
